<div class="splitted-screen" [ngClass]="{'full' : fullContainer}">
    <div class="left-side" [ngClass]="{'contrast' : contrastSide === 'left'}">
        <ng-content select="[left-content]"></ng-content>
    </div>
    <div class="right-side" [ngClass]="{'contrast' : contrastSide === 'right'}">
        <ng-content select="[right-content]"></ng-content>
    </div>
</div>